<template lang="pug">
  .facturas-list-items
    .container
      .row.box-1
        .col-sm-6(data-toggle="collapse" :data-target="'#demo-'+index")
          span.img-cn
            img(:src="img.derecha" width="8")
          p.name(v-if="order.client") {{order.client.name}}
            span(v-if="order.client.external_code") ({{order.client.external_code }})
        .col-sm-2(@click="setOrder")
          p.text-right(v-if="order.client")  {{order.number}}
        .col-sm-1(@click="setOrder")
          p.text-center {{order.invoice_datetime | moment("DD-MM-YYYY")}}
        .col-sm-1(@click="setOrder")
          p.text-right {{order.total | format-money}} {{order.currency_symbol}}
        .col-sm-1(@click="setOrder")
          p.text-center.state-cn
            // span(:class="order.state") {{state}}
            img(:src="img.ver" width="18")
        .col-sm-1( @click="getFacturaPDF")
          p.text-center.state-cn
            img(:src="img.descargar" width="18")

      .row.box-2(:id="`demo-${index}`" class="collapse" v-if="order.client")
        .col-sm-6.col-md-3
          p #[translate Identificador]: #[strong {{checkEmpty(order.client.external_code)}}]
          p #[translate Dirección]: #[strong {{checkEmpty(order.client.address)}}]
          p #[translate Localidad]: #[strong {{checkEmpty(order.client.locality)}}]
          p #[translate Provincia]: #[strong {{checkEmpty(order.client.province)}}]
          p #[translate Código Postal]: #[strong {{checkEmpty(order.client.postal_code)}}]
        .col-sm-6.col-md-3
          p #[translate Persona de contacto]: #[strong {{checkEmpty(order.client.contact)}}]
          p #[translate Teléfono]: #[strong {{checkEmpty(order.client.phone)}}]
          p #[translate Horario]: #[strong {{order.client.morning_open_times}} - {{order.client.afternoon_open_times}}]
          p #[translate Observaciones]: #[strong {{checkEmpty(order.client.observations)}}]
</template>
<script>
import SrvOrder from '@/services/facturas'
export default {
  name: 'FacturaListItem',
  props: ['order', 'index'],
  data () {
    return {
      img: {
        'derecha': require('@/assets/img/icos/derecha.svg'),
        'ver': require('@/assets/img/icos/ver-oferta.svg'),
        'descargar': require('@/assets/img/icos/ico_pdf.svg')
      }
    }
  },
  computed: {
    state () {
      let result = '-'
      if (this.order.state_values) {
        this.order.state_values.map(item => {
          if (item.code === this.order.state) {
            result = item.value
          }
        })
      }
      return result
    },
    isBillableCenter () {
      return this.order.billable_center ? this.$gettext('Si') : this.$gettext('No')
    },
    isTypeApp () {
      // console.log(`--- typeApp: ${this.$config.type}`)
      return this.$config.type
    }
  },
  methods: {
    getFacturaPDF () {
      this.$emit('setOnPdfLoading')
      SrvOrder.getFacturaPdf(this.order.id)
        .then(res => {
          if (res.status === 200) {
            const blob = new Blob([res.data], {type: 'application/pdf'})
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `Factura-${this.order.number}.pdf`
            link.click()
            this.$emit('setOffPdfLoading')
          } else {
            this.messageError = this.$gettext('Se ha producido un error. Intentelo más tarde.')
            this.$emit('setOffPdfLoading')
          }
        }, () => {
          // console.log('----->' + error)
          this.messageError = this.$gettext('Se ha producido un error. Intentelo más tarde.')
          this.$emit('setOffPdfLoading')
        })
    },
    checkEmpty (v) {
      return (v === null || v === '') ? '-' : v
    },
    setOrder () {
      // console.log('Order seleccionada: ', this.order.id)
      this.$router.push({name: 'facturaSingle', params: {id: this.order.id}})
    }
  }
}
</script>
<style lang="scss" scoped>
  .facturas-list-items{
    color:#494f58;
  }

  .box-1{
    @include transition();
    font-size: 14px;
    color: #4D4F5C;
    font-weight: $regular;
    border:1px solid #fff;
    cursor: pointer;

    & > *{
      padding-top:12px;
      padding-bottom:8px;
    }

    &:hover, &:focus{
      background-color: rgba(#129FE9, .2);
      border:1px solid #00ADFC;

      .name{
        font-weight: $medium;
      }
    }

    p{
      margin:0;

      &.name{
        text-transform: uppercase;
        margin-left: 34px;
        @include ellipsis();
        cursor: pointer;
        @include transition();
      }
    }
  }

  .img-cn{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 15px;
    height: 22px;
    margin: auto;
    padding-right: 40px;
    img{
      @include transition();
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  }

  [aria-expanded="true"]{
      img{
        -moz-transform: rotate(90deg) translate(0px);
        -o-transform: rotate(90deg) translate(0px);
        -ms-transform: rotate(90deg) translate(0px);
        -webkit-transform: rotate(90deg) translate(0px);
        transform: rotate(90deg) translate(0px);
      }
  }

  .box-2{
    padding: 16px 0 46px 34px;
    background-color: #fff;
    border-bottom: 1px solid #F5F6FA;
    color: #4D4F5C;

    strong{
      font-weight: $regular;
    }
  }

  .state-cn{
    /*span {
      width: 156px;
      text-align: center;
      color: $orange;
      margin-left:0;
    }

    img{
      float: right;
    }

    .S{
      color: $green;
    }*/
  }

  .isBillable{
    color: $green-true;
  }

</style>
